import React from "react";
import { pure } from "recompose";

import "./custom.scss";
import "./selenta.scss";

function ExternalMenu({ handleCloseModal }) {
  return (
    <div className="ExternalMenu" itemScope="">
      <header className="site-header" itemScope="">
        <div className="wrap">
          <div className="title-area">
            <p className="site-title" itemProp="headline">
              <a href="https://selentagroup.com/en/" title="Selenta Group">
                Selenta Group
              </a>
            </p>
            <p className="site-description" itemProp="description">
              Home
            </p>
          </div>
          <div id="burguer" className="opened"></div>
          <div className="menus opened">
            <div className="wrap">
              <div onClick={handleCloseModal} className="close-menu"></div>
            </div>
            <div className="primary">
              <div className="menu-menugeneralv2-container">
                <ul id="menu-menugeneralv2" className="menu">
                  <li
                    id="menu-item-1339"
                    className="qtranxs-lang-menu qtranxs-lang-menu-en menu-item menu-item-type-custom menu-item-object-custom current-menu-parent menu-item-has-children menu-item-1339">
                    <a title="EN" href="#" itemProp="url">
                      Language:&nbsp;
                      <img
                        src="https://selentagroup.com/wp-content/plugins/qtranslate-x/flags/gb.png"
                        alt="EN"></img>
                      <span></span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="menu-item-1910"
                        className="qtranxs-lang-menu-item qtranxs-lang-menu-item-es menu-item menu-item-type-custom menu-item-object-custom menu-item-1910">
                        <a
                          title="ES"
                          href="https://selentagroup.com/es/el-grupo/experiencia/"
                          itemProp="url">
                          <img
                            src="https://selentagroup.com/wp-content/plugins/qtranslate-x/flags/es.png"
                            alt="ES"></img>
                          &nbsp;ES<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1911"
                        className="qtranxs-lang-menu-item qtranxs-lang-menu-item-en menu-item menu-item-type-custom menu-item-object-custom current-menu-item menu-item-1911 active">
                        <a
                          title="EN"
                          href="https://selentagroup.com/en/the-group/experience/"
                          itemProp="url">
                          <img
                            src="https://selentagroup.com/wp-content/plugins/qtranslate-x/flags/gb.png"
                            alt="EN"></img>
                          &nbsp;EN<span></span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-656"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-page-ancestor current-menu-ancestor current-menu-parent current-custom-parent current_page_parent current_page_ancestor menu-item-has-children menu-item-656">
                    <a href="https://selentagroup.com/en/the-group/" itemProp="url">
                      The group<span></span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="menu-item-751"
                        className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-375 current_page_item menu-item-751">
                        <a href="https://selentagroup.com/en/the-group/experience/" itemProp="url">
                          Experience<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-1417"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1417">
                        <a href="https://selentagroup.com/en/the-group/team/" itemProp="url">
                          Team<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-862"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-862">
                        <a href="https://selentagroup.com/en/the-group/philosophy/" itemProp="url">
                          Philosophy<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-749"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-749">
                        <a
                          href="https://selentagroup.com/en/the-group/recognitions/"
                          itemProp="url">
                          Recognitions<span></span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-1909"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1909">
                    <a href="https://selentagroup.com/en/divisions/" itemProp="url">
                      Divisions<span></span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="menu-item-753"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-753">
                        <a
                          href="https://selentagroup.com/en/divisions/hotels-resorts/"
                          itemProp="url">
                          Hotels &amp; Resorts<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-755"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-755">
                        <a href="https://selentagroup.com/en/divisions/restaurants/" itemProp="url">
                          Gastronomy<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-752"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-752">
                        <a
                          href="https://selentagroup.com/en/divisions/facility-services/"
                          itemProp="url">
                          Facility services<span></span>
                        </a>
                      </li>
                      <li
                        id="menu-item-754"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-754">
                        <a
                          href="https://selentagroup.com/en/divisions/partnerships/"
                          itemProp="url">
                          Partnerships<span></span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-658"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-658">
                    <a href="https://selentagroup.com/en/press/" itemProp="url">
                      Press Office<span></span>
                    </a>
                  </li>
                  <li
                    id="menu-item-659"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-659">
                    <a href="https://selentagroup.com/en/careers/" itemProp="url">
                      Careers<span></span>
                    </a>
                  </li>
                  <li
                    id="menu-item-661"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-661">
                    <a href="https://selentagroup.com/en/rsc/" itemProp="url">
                      RSC<span></span>
                    </a>
                  </li>
                  <li
                    id="menu-item-660"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-660">
                    <a href="https://selentagroup.com/en/contact/" itemProp="url">
                      Contact<span></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default pure(ExternalMenu);
